module.exports = __webpack_public_path__ + "img/logo.c0ced6b6.svg";